
/**
* Licensed Materials - Property of IBM
* IBM Cognos Products: ba-dashboard-core
* (C) Copyright IBM Corp. 2018, 2020
* US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
*/
define({
	'generalInfo': '일반',
	'widgetId': '위젯 ID',
	'widgetType': '위젯 유형',
	'serviceability': '서비스 가용성',
	'copyButton': '복사',
	'closeButton': '닫기',
	'specification': '스펙',
	'viewSpecification': '스펙 보기'
});
